import { render, staticRenderFns } from "./DocumentIndex.vue?vue&type=template&id=1bcf54fb&scoped=true&"
import script from "./DocumentIndex.vue?vue&type=script&lang=js&"
export * from "./DocumentIndex.vue?vue&type=script&lang=js&"
import style0 from "./DocumentIndex.vue?vue&type=style&index=0&id=1bcf54fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf54fb",
  null
  
)

export default component.exports